import { Controller } from '@hotwired/stimulus';

export default class FacultySelectionController extends Controller {
  static targets = [
    'frame',
    'form',
    'subject',
    'subjectCourse',
    'classNumber'
  ];

  scheduleChanged() {
    this.#selectionChanged();
  }

  facultyChanged() {
    this.subjectTarget.value       = null;
    this.subjectCourseTarget.value = null;
    this.classNumberTarget.value   = null;
    this.#selectionChanged();
  }

  subjectChanged() {
    this.subjectCourseTarget.value = null;
    this.classNumberTarget.value   = null;
    this.#selectionChanged();
  }

  subjectCourseChanged() {
    this.classNumberTarget.value = null;
    this.#selectionChanged();
  }

  classNumberChanged() {
    this.#selectionChanged();
  }

  #selectionChanged() {
    const url      = new URL(location.href);
    const formData = new FormData(this.formTarget);
    url.search     = new URLSearchParams(formData).toString();

    this.frameTarget.src = url.href;
    this.frameTarget.reload();
  }
}
